<script setup lang="ts">
import { defineProps } from 'vue'
import ListContact from '../components/ListContact.vue'

const { phone } = defineProps(['phone'])
</script>

<template>
  <ListContact v-if="phone" :phone="phone" />
</template>
